<template>
  <v-layout wrap class="raster-color-buttons justify-center">
    <v-flex shrink>
      <v-btn text 
        class="modal-cta"
        :class="[{active: hasColorPalette}, colorClass]"
        @click="$emit('toggleColor')">Color</v-btn>
      <v-btn text
        class="modal-cta"
        :class="[{active: isInverted}, colorClass]"
        @click="$emit('invertColor')">Invert</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: "rasterColorButtons",
  props: ["isInverted", "hasColorPalette"]
}
</script>